import { copyToClipboard } from '@gonfalon/dom/copyToClipboard';
import { msg } from '@gonfalon/messages/msg';
import { IconButton, Text, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import styles from './EntityKey.module.css';

export function EntityKey({ value }: { value: string }) {
  return (
    <div className={styles.key}>
      <Text className={styles.value}>{value}</Text>
      <TooltipTrigger>
        <IconButton
          onPress={async () => {
            await copyToClipboard(value, msg('flags.entityKey.copiedToast', { value }));
          }}
          aria-label={msg('flags.entityKey.copyLabel', { value })}
          icon="copy-clipboard"
          size="small"
          variant="minimal"
        />
        <Tooltip placement="bottom">{msg('flags.entityKey.copyLabel', { value })}</Tooltip>
      </TooltipTrigger>
    </div>
  );
}
